import { render } from "./CredentialsForm.html?vue&type=template&id=4807472f&ts=true&external"
import script from "./CredentialsForm.vue?vue&type=script&lang=ts"
export * from "./CredentialsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__